var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 15.0938H12.1875V19.7213L10.245 17.7863L9.1875 18.8438L12.9375 22.5938L16.6875 18.8438L15.63 17.7863L13.6875 19.7213V15.0938H21.9375V13.5938H3.9375V15.0938Z",
    fill: "#BEC9CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 5.34375L10.245 6.40125L12.1875 4.46625V9.09375H3.9375V10.5938H21.9375V9.09375H13.6875V4.46625L15.63 6.40125L16.6875 5.34375L12.9375 1.59375L9.1875 5.34375Z",
    fill: "#BEC9CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragVertical);
export default __webpack_public_path__ + "static/media/drag-vertical.64ea0dbb35014486a4eb80016c2e3708.svg";
export { ForwardRef as ReactComponent };